<mat-form-field
    [floatLabel]="asFormsControl().floatingLabelNever && 'never'"
    class="app-datepicker"
>
    <input
        matInput
        #datepickerInput
        readonly
        [matDatepicker]="datepicker"
        [min]="asFormsControl().minDate"
        [max]="asFormsControl().maxDate"
        [placeholder]="control.placeholder"
        (click)="openDatepicker(datepicker)"
        (dateChange)="changeValue($event)"
        [disabled]="disabled"

        [(ngModel)]="asFormsControl().value"
    >
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>

    <mat-datepicker
        #datepicker
        [disabled]="control.disabled"
        [startAt]="asFormsControl().value"
        (opened)="onTouched && onTouched()"
        (yearSelected)="yearHandler($event, datepicker)"
        startView="multi-year"
        [panelClass]="'year-datepicker-calendar'"
    ></mat-datepicker>
</mat-form-field>

<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
